module.exports = __webpack_public_path__ + "img/oxford-logo2.2a267e57.png";